/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createSubscriptionDataIntervalSchema = z.enum(['monthly', 'yearly'])

export type CreateSubscriptionDataIntervalSchema = z.infer<typeof createSubscriptionDataIntervalSchema>
